import { defineComponent as _defineComponent } from 'vue'
import { vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3482db7a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "radio" }
const _hoisted_2 = ["value"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "check" }, null, -1))
const _hoisted_4 = { class: "ml-2" }

import { computed } from "vue"

export default /*#__PURE__*/_defineComponent({
  __name: 'BulmaRadio',
  props: {
  value: {
    type: String,
    required: true
  },
  nativeValue: {
    type: String,
    required: true
  }
},
  emits: ['update:value'],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

const radioValue = computed({
  get: () => props.value,
  set: updatedValue => { emit('update:value', updatedValue) }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((radioValue).value = $event)),
      type: "radio",
      value: __props.nativeValue
    }, null, 8, _hoisted_2), [
      [_vModelRadio, radioValue.value]
    ]),
    _hoisted_3,
    _createElementVNode("span", _hoisted_4, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})